<div class="dialog-viewer container-fluid">
    <div class="row">
        <h2 mat-dialog-title>Entry Details</h2>
    </div>
    <mat-dialog-content>
        <div class="waiver-details">
            <div class="row mb-2">
                <div class="col-12 col-md-6">
                    <h2>Customer Information</h2>
                    <hr />
                    <p><b>Name:</b> {{data.firstName}} {{data.lastName}}</p>
                    <p><b>Email:</b> {{data.emailAddress}}</p>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-12 col-md-6">
                    <h2>Booking Information</h2>
                    <hr />
                    <p><b>Confirmation Number:</b> {{data.confirmationNumber || 'N/A'}}</p>
                    <p><b>Start Time:</b> {{data.startTime | date: 'MMM d, y, h:mm a'}}</p>
                    <p><b>End Time:</b> {{data.endTime | date: 'MMM d, y, h:mm a'}}</p>
                    <p><b>Price:</b> {{data.totalPrice | currency}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <h2>Waiver Status</h2>
                    <hr />
                    <ejs-message *ngIf="data.signature" id="signed" content="Digital Waiver has been signed"
                        severity="Success"></ejs-message>
                    <ejs-message *ngIf="!data.signature" id="unsigned" content="Digital Waiver is unsigned"
                        severity="Error"></ejs-message>
                    <p><b>Sent Date:</b> {{data.sentDate | date: 'MMM d, y, h:mm a'}}</p>
                    <p><b>Signed Date:</b> {{data.signature ? (data.signedDate | date: 'MMM d, y, h:mm a') :
                        'N/A'}}</p>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button (click)="close()">Close</button>
    </mat-dialog-actions>
</div>